var map = {
	"./env.debug": "./src/config/env.debug.js",
	"./env.debug.js": "./src/config/env.debug.js",
	"./env.dev": "./src/config/env.dev.js",
	"./env.dev.js": "./src/config/env.dev.js",
	"./env.devlopment": "./src/config/env.devlopment.js",
	"./env.devlopment.js": "./src/config/env.devlopment.js",
	"./env.hd": "./src/config/env.hd.js",
	"./env.hd.js": "./src/config/env.hd.js",
	"./env.pre": "./src/config/env.pre.js",
	"./env.pre.js": "./src/config/env.pre.js",
	"./env.prod": "./src/config/env.prod.js",
	"./env.prod.js": "./src/config/env.prod.js",
	"./env.production": "./src/config/env.production.js",
	"./env.production.js": "./src/config/env.production.js",
	"./env.uat": "./src/config/env.uat.js",
	"./env.uat.js": "./src/config/env.uat.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/config sync recursive ^\\.\\/env\\..*$";